import { globalizeSelectors } from '../Utils';
import type {
  HoverColor,
  HoverColorAction,
  HoverColorState,
} from '../types/HoverColor';

const types = {
  SET_HOVER_COLOR: 'SET_HOVER_COLOR',
  SET_SELECTED_NAME: 'SET_SELECTED_NAME',
} as const;

const actions = {
  setHoverColor: (color: HoverColor | null): HoverColorAction => ({
    type: types.SET_HOVER_COLOR,
    payload: color,
  }),
  setSelectedName: (name: string | null): HoverColorAction<string | null> => ({
    type: types.SET_SELECTED_NAME,
    payload: name,
  }),
};

const initial_state: HoverColorState = {
  color: null,
  name: null,
};

/**
 * This needs to be separate store for performance reasons as mouse over changes data a lot
 * multiple repaints are avoided when this is connected to minimal amount of components!
 * reducer which updates the order state in data store
 * @param {*} state
 * @param {*} action
 */
function reducer(
  state: HoverColorState = initial_state,
  action: HoverColorAction
): HoverColorState {
  switch (action.type) {
    case types.SET_HOVER_COLOR: {
      return { ...state, color: action.payload as HoverColor | null };
    }
    case types.SET_SELECTED_NAME: {
      return { ...state, name: action.payload as string | null };
    }
    default: {
      return state;
    }
  }
}

const mountPath = 'hover_color';

const localSelectors = {
  name: (state: HoverColorState): string | null => state.name,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export { types as actionTypes, actions as default, reducer, selectors };
